<template>
  <div class="p-3">
    <c-tabs variant="pills" vertical>
      <c-tab active title="WP Engine">
        <w-p-engine :organisation="organisation" />
      </c-tab>
    </c-tabs>
  </div>
</template>

<script>
import WPEngine from './wpengine';

export default {
  components: {
    WPEngine,
  },
  props: {
    organisation: Object,
  },
};
</script>
